document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const normalizeCollaboratorId = (value) => {
    const candidate = String(value || '').trim();
    return /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(candidate) ? candidate : '';
  };
  const referralParams = new URLSearchParams(window.location.search);
  const incomingCollaboratorId = normalizeCollaboratorId(
    referralParams.get('collab') ||
    referralParams.get('collaborator') ||
    referralParams.get('affiliate_id') ||
    referralParams.get('ref')
  );
  let collaboratorId = incomingCollaboratorId;
  try {
    if (incomingCollaboratorId) sessionStorage.setItem('ck_collaborator_id', incomingCollaboratorId);
    collaboratorId = incomingCollaboratorId || normalizeCollaboratorId(sessionStorage.getItem('ck_collaborator_id'));
  } catch (_) {}

  const scrollBook = document.querySelector('[data-scroll-book]');
  const launchHero = document.querySelector('.launch-hero');
  if (scrollBook && launchHero) {
    const syncScrollBook = () => scrollBook.classList.toggle('is-visible', window.scrollY > Math.min(520, launchHero.offsetHeight * 0.55));
    syncScrollBook();
    window.addEventListener('scroll', syncScrollBook, { passive: true });
  }

  document.querySelectorAll('[data-testimonials-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-testimonials-track]');
    const previous = carousel.querySelector('[data-testimonials-prev]');
    const next = carousel.querySelector('[data-testimonials-next]');
    const firstCard = carousel.querySelector('[data-testimonial-card]');
    if (!track || !previous || !next || !firstCard) return;
    const cardStep = () => firstCard.getBoundingClientRect().width + 18;
    const syncControls = () => {
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 4;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => window.requestAnimationFrame(syncControls), { passive: true });
    window.addEventListener('resize', syncControls);
    syncControls();
  });

  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-primary-nav]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menu.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  document.querySelectorAll('[data-comparison]').forEach((comparison) => {
    const range = comparison.querySelector('[data-comparison-range]');
    if (!range) return;
    const syncComparison = () => comparison.style.setProperty('--position', `${range.value}%`);
    range.addEventListener('input', syncComparison);
    syncComparison();

    if (!comparison.hasAttribute('data-comparison-auto') || !window.requestAnimationFrame) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = Number(range.value) || 50;
    let direction = 1;
    let previousTime = 0;
    let resumeAt = 0;
    let hovering = false;
    let dragging = false;
    let focused = false;
    let visible = true;

    range.addEventListener('input', () => {
      current = Number(range.value) || current;
      resumeAt = performance.now() + 4000;
    });
    comparison.addEventListener('mouseenter', () => { hovering = true; });
    comparison.addEventListener('mouseleave', () => {
      hovering = false;
      resumeAt = performance.now() + 1200;
    });
    range.addEventListener('pointerdown', () => { dragging = true; });
    window.addEventListener('pointerup', () => {
      if (!dragging) return;
      dragging = false;
      current = Number(range.value) || current;
      resumeAt = performance.now() + 4000;
    });
    range.addEventListener('focus', () => { focused = true; });
    range.addEventListener('blur', () => {
      focused = false;
      resumeAt = performance.now() + 2500;
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        visible = Boolean(entry && entry.isIntersecting);
      }, { threshold: 0.2 });
      observer.observe(comparison);
    }

    const animateComparison = (time) => {
      if (!previousTime) previousTime = time;
      const elapsed = Math.min((time - previousTime) / 1000, 0.05);
      previousTime = time;

      if (visible && !document.hidden && !reducedMotion.matches && !hovering && !dragging && !focused && time >= resumeAt) {
        current += direction * 14 * elapsed;
        if (current >= 88) {
          current = 88;
          direction = -1;
        } else if (current <= 12) {
          current = 12;
          direction = 1;
        }
        range.value = current.toFixed(1);
        syncComparison();
      }

      window.requestAnimationFrame(animateComparison);
    };

    window.requestAnimationFrame(animateComparison);
  });

  document.querySelectorAll('[data-site-story]').forEach((section) => {
    const video = section.querySelector('[data-site-story-video]');
    const toggle = section.querySelector('[data-site-story-toggle]');
    const icon = section.querySelector('[data-site-story-icon]');
    const label = section.querySelector('[data-site-story-label]');
    if (!video || !toggle) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncVideoToggle = () => {
      const paused = video.paused;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      if (icon) icon.textContent = paused ? '▶' : 'Ⅱ';
      if (label) label.textContent = paused ? 'Play' : 'Pause';
    };

    if (reducedMotion.matches) video.pause();
    video.addEventListener('play', syncVideoToggle);
    video.addEventListener('pause', syncVideoToggle);
    toggle.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });
    syncVideoToggle();
  });

  const asDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('The selected photo could not be read. Please choose it again.'));
    reader.readAsDataURL(file);
  });

  const bookTypeLabels = {
    bestie: 'Bestie Book', family: 'Kids & family', creator: 'Creator giveaway', birthday: 'Birthday memories',
    grandparents: 'Grandparents', couple: 'Couples & anniversaries', school: 'School memories', team: 'Teams & coaches',
    pet: 'Pets', vacation: 'Vacation memories', realestate: 'Real estate closing keepsake', other: 'Other / Custom idea'
  };
  const clearRememberedPreview = () => {
    try {
      ['ck_preview_project', 'ck_preview_token', 'ck_preview_image', 'ck_preview_saved', 'ck_child_name', 'ck_preview_status', 'ck_book_type', 'ck_custom_idea', 'ck_detail_level', 'ck_property_address', 'ck_agent_name', 'ck_brokerage', 'ck_recipient_type'].forEach((key) => sessionStorage.removeItem(key));
    } catch (_) {}
  };
  clearRememberedPreview();

  document.querySelectorAll('[data-preview-demo], [data-preview-live]').forEach((preview) => {
    const isLive = preview.hasAttribute('data-preview-live');
    const realtorPreviewOnly = preview.hasAttribute('data-realtor-preview');
    const start = preview.querySelector('[data-preview-start]');
    const creating = preview.querySelector('[data-preview-creating]');
    const ready = preview.querySelector('[data-preview-ready]');
    const photoInput = preview.querySelector('[data-preview-photo]');
    const nameInput = preview.querySelector('[data-child-name]');
    const bookTypeInput = preview.querySelector('[data-book-type]');
    const customIdeaWrap = preview.querySelector('[data-custom-idea-wrap]');
    const customIdeaInput = preview.querySelector('[data-custom-idea]');
    const realEstateFields = preview.querySelector('[data-real-estate-fields]');
    const agentNameInput = preview.querySelector('[data-agent-name]');
    const brokerageInput = preview.querySelector('[data-brokerage]');
    const recipientTypeInput = preview.querySelector('[data-recipient-type]');
    const subjectLabel = preview.querySelector('[data-subject-label]');
    const previewHeading = preview.querySelector('[data-preview-heading]');
    const previewIntro = preview.querySelector('[data-preview-intro]');
    const detailInputs = Array.from(preview.querySelectorAll('[data-detail-level]'));
    const easyDetailTitle = preview.querySelector('[data-easy-detail-title]');
    const easyDetailCopy = preview.querySelector('[data-easy-detail-copy]');
    const detailedDetailTitle = preview.querySelector('[data-detailed-detail-title]');
    const detailedDetailCopy = preview.querySelector('[data-detailed-detail-copy]');
    const consent = preview.querySelector('[data-consent]');
    const makeButton = preview.querySelector('[data-make-preview]');
    const resetButton = preview.querySelector('[data-reset-preview]');
    const deleteButton = preview.querySelector('[data-delete-preview]');
    const uploadPhoto = preview.querySelector('[data-upload-photo]');
    const readyPhoto = preview.querySelector('[data-ready-photo]');
    const generatedPreview = preview.querySelector('[data-generated-preview]');
    const previewComparison = preview.querySelector('[data-preview-comparison]');
    const previewRange = preview.querySelector('[data-preview-range]');
    const skipPreviewLink = preview.querySelector('[data-skip-preview]');
    const errorMessage = preview.querySelector('[data-preview-error]');
    const uploadTitle = preview.querySelector('[data-upload-title]');
    const uploadDetail = preview.querySelector('[data-upload-detail]');
    const creatingTitle = preview.querySelector('[data-creating-title]');
    const creatingCopy = preview.querySelector('[data-creating-copy]');
    const readyTitle = preview.querySelector('[data-ready-title]');
    const readyCopy = preview.querySelector('[data-ready-copy]');
    const bar = creating?.querySelector('[data-progress-bar]');
    const label = creating?.querySelector('[data-progress-label]');
    if (!start || !creating || !ready || !photoInput || !nameInput || !consent || !makeButton || !resetButton || !bar || !label) return;

    let photoUrl = '';
    let busy = false;
    let currentPayload = null;
    let progressTimers = [];

    const clearProgressTimers = () => {
      progressTimers.forEach((timer) => window.clearTimeout(timer));
      progressTimers = [];
    };
    const setProgress = (value) => {
      bar.style.width = `${value}%`;
      label.textContent = `${value}%`;
    };
    const scheduleProgress = (steps) => {
      clearProgressTimers();
      progressTimers = steps.map(([value, delay]) => window.setTimeout(() => setProgress(value), delay));
    };
    const setPreviewPosition = (value = 50) => {
      if (previewComparison) previewComparison.style.setProperty('--position', `${value}%`);
      if (previewRange) previewRange.value = String(value);
    };
    const detailLevel = () => detailInputs.find((input) => input.checked)?.value === 'detailed' ? 'detailed' : 'easy';
    const realEstateSelected = () => bookTypeInput?.value === 'realestate';
    const syncDetailCopy = () => {
      if (easyDetailTitle) easyDetailTitle.textContent = realEstateSelected() ? 'Clean architecture' : 'Easy to color';
      if (easyDetailCopy) easyDetailCopy.textContent = realEstateSelected() ? 'Clear rooflines, rooms and permanent features with less decorative clutter.' : 'Bold lines, large open spaces, and a simpler background.';
      if (detailedDetailTitle) detailedDetailTitle.textContent = realEstateSelected() ? 'Detailed architecture' : 'More detailed';
      if (detailedDetailCopy) detailedDetailCopy.textContent = realEstateSelected() ? 'Keeps more trim, fixtures and landscaping—still pure black and white.' : 'More hair, clothing, and background detail—still no shading.';
    };
    const customSelected = () => bookTypeInput?.value === 'other' && Boolean(customIdeaInput);
    const syncCustomIdea = () => {
      if (customIdeaWrap) customIdeaWrap.hidden = !customSelected();
      if (customIdeaInput) customIdeaInput.required = customSelected();
    };
    const valid = () => {
      const file = photoInput.files && photoInput.files[0];
      const validRealEstate = !realEstateSelected() || realtorPreviewOnly || (agentNameInput?.value.trim() && brokerageInput?.value.trim() && recipientTypeInput?.value);
      makeButton.disabled = busy || !(file && file.size <= 10 * 1024 * 1024 && nameInput.value.trim() && consent.checked && (!customSelected() || customIdeaInput?.value.trim()) && validRealEstate);
    };
    const updateNames = () => {
      const displayName = realtorPreviewOnly || realEstateSelected() ? 'Your property' : 'Your photo';
      if (creatingTitle) creatingTitle.textContent = realEstateSelected() ? 'Outlining your property photo…' : 'Creating your coloring page…';
      if (creatingCopy) creatingCopy.textContent = realEstateSelected() ? 'Preserving the actual rooflines, rooms and permanent features while removing visual clutter.' : 'Finding the important shapes, simplifying the background and drawing clean outlines.';
      if (readyTitle) readyTitle.textContent = realEstateSelected() ? 'Your property—outlined' : 'Your photo—outlined';
      if (readyCopy) readyCopy.textContent = realEstateSelected()
        ? 'This was only a sample. It will not be placed in the book or attached to checkout.'
        : 'This was only a sample. It will not be placed in your book or attached to checkout.';
      return displayName;
    };
    const syncBookType = () => {
      syncCustomIdea();
      const isRealEstate = realEstateSelected();
      preview.classList.toggle('is-real-estate', isRealEstate);
      if (realEstateFields) realEstateFields.hidden = !isRealEstate;
      [agentNameInput, brokerageInput, recipientTypeInput].filter(Boolean).forEach((input) => { input.required = isRealEstate; });
      if (subjectLabel) subjectLabel.textContent = isRealEstate ? 'Property address' : 'Name for the book';
      nameInput.placeholder = isRealEstate ? '123 Main Street, City, State' : 'Avery';
      if (previewHeading) previewHeading.textContent = isRealEstate ? 'See the listing—outlined' : 'See someone you love—outlined';
      if (previewIntro) previewIntro.textContent = isRealEstate ? 'Upload one strong listing photo to test the architectural style. No email or card required.' : 'No account, email, or credit card required. See your preview first.';
      if (!photoInput.files?.length) {
        if (uploadTitle) uploadTitle.textContent = isRealEstate ? 'Choose a strong listing photo' : 'Choose a clear photo';
        if (uploadDetail) uploadDetail.textContent = isRealEstate ? 'Front exterior recommended · JPG, PNG, or WebP · maximum 10 MB' : 'JPG, PNG, or WebP · maximum 10 MB';
      }
      syncDetailCopy();
      updateNames();
    };
    const showError = (message) => {
      if (!errorMessage) return;
      errorMessage.textContent = message;
      errorMessage.hidden = false;
    };
    const readJson = async (response) => {
      const responseText = await response.text();
      try { return responseText ? JSON.parse(responseText) : {}; } catch (_) { return {}; }
    };
    const actionEndpoint = (action) => {
      const [path, parameters] = preview.dataset.previewEndpoint.split('?');
      return `${path}/${action}${parameters ? `?${parameters}` : ''}`;
    };
    const trackPreviewComplete = (payload) => {
      const projectId = String(payload.projectId || '').replace(/[^A-Za-z0-9_-]/g, '');
      if (!projectId) return;
      const trackedKey = `ck_meta_preview_${projectId}`;
      try { if (sessionStorage.getItem(trackedKey)) return; } catch (_) {}
      if (typeof window.fbq !== 'function') return;
      window.fbq('trackCustom', 'PreviewComplete', { content_name:'Free personalized coloring-book preview', content_category:bookTypeInput?.value || 'family' });
      try { sessionStorage.setItem(trackedKey, new Date().toISOString()); } catch (_) {}
    };
    const waitForPreview = async (initialPayload) => {
      if (initialPayload.imageUrl) return initialPayload;
      if (!initialPayload.projectId || !initialPayload.previewToken) throw new Error('The preview service did not start correctly. Please try again.');
      const separator = preview.dataset.previewEndpoint.includes('?') ? '&' : '?';
      const statusUrl = `${preview.dataset.previewEndpoint}${separator}projectId=${encodeURIComponent(initialPayload.projectId)}&previewToken=${encodeURIComponent(initialPayload.previewToken)}`;
      const deadline = Date.now() + 3 * 60 * 1000;
      let polls = 0;
      while (Date.now() < deadline) {
        await new Promise((resolve) => window.setTimeout(resolve, polls < 4 ? 1500 : 2500));
        const response = await fetch(statusUrl, { method:'GET', headers:{ accept:'application/json' }, cache:'no-store' });
        const payload = await readJson(response);
        if (response.ok && payload.imageUrl) return payload;
        if (!response.ok && response.status !== 202) throw new Error(payload.error || 'The preview service could not create this image. Please try again.');
        polls += 1;
        setProgress(Math.min(97, 90 + Math.floor(polls / 3)));
      }
      throw new Error('This preview is taking longer than expected. Please try again.');
    };

    photoInput.addEventListener('change', () => {
      if (photoUrl) URL.revokeObjectURL(photoUrl);
      const file = photoInput.files && photoInput.files[0];
      if (errorMessage) errorMessage.hidden = true;
      if (file && file.size > 10 * 1024 * 1024) {
        uploadPhoto.hidden = true;
        uploadTitle.textContent = 'Choose a smaller photo';
        uploadDetail.textContent = 'The maximum file size is 10 MB.';
        showError('Photo must be smaller than 10 MB.');
      } else if (file) {
        photoUrl = URL.createObjectURL(file);
        uploadPhoto.src = photoUrl;
        readyPhoto.src = photoUrl;
        uploadPhoto.hidden = false;
        uploadTitle.textContent = 'Photo selected';
        uploadDetail.textContent = file.name;
      }
      valid();
    });
    nameInput.addEventListener('input', () => { updateNames(); valid(); });
    bookTypeInput?.addEventListener('change', () => { syncBookType(); valid(); });
    customIdeaInput?.addEventListener('input', valid);
    [agentNameInput, brokerageInput, recipientTypeInput].filter(Boolean).forEach((input) => {
      input.addEventListener('input', valid);
      input.addEventListener('change', valid);
    });
    detailInputs.forEach((input) => input.addEventListener('change', () => { syncDetailCopy(); updateNames(); }));
    consent.addEventListener('change', valid);
    previewRange?.addEventListener('input', () => setPreviewPosition(previewRange.value));
    const requestedPreviewType = referralParams.get('book');
    if (!realtorPreviewOnly && requestedPreviewType && Object.prototype.hasOwnProperty.call(bookTypeLabels, requestedPreviewType) && bookTypeInput?.querySelector(`option[value="${requestedPreviewType}"]`)) {
      bookTypeInput.value = requestedPreviewType;
    }
    const requestedCustomIdea = referralParams.get('idea');
    if (requestedCustomIdea && customIdeaInput) customIdeaInput.value = requestedCustomIdea.slice(0, 160);
    syncBookType();

    makeButton.addEventListener('click', async () => {
      if (makeButton.disabled || busy) return;
      const file = photoInput.files && photoInput.files[0];
      if (!file) return;
      const displayName = updateNames();
      busy = true;
      valid();
      if (errorMessage) errorMessage.hidden = true;
      start.hidden = true;
      ready.hidden = true;
      creating.hidden = false;
      setProgress(0);

      if (!isLive) {
        scheduleProgress([[18, 80], [48, 420], [76, 820], [94, 1220], [100, 1550]]);
        progressTimers.push(window.setTimeout(() => {
          setPreviewPosition(50);
          creating.hidden = true;
          ready.hidden = false;
          busy = false;
          if (deleteButton) deleteButton.hidden = true;
          currentPayload = { demo:true };
          valid();
        }, 1730));
        return;
      }

      scheduleProgress([[12, 100], [36, 1000], [58, 3500], [76, 8000], [90, 18000]]);
      try {
        const response = await fetch(preview.dataset.previewEndpoint, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            childName: nameInput.value.trim(),
            collaboratorId,
            bookType: bookTypeInput?.value || 'family',
            customIdea: customSelected() ? customIdeaInput?.value.trim() || '' : '',
            propertyAddress: realEstateSelected() && !realtorPreviewOnly ? nameInput.value.trim() : '',
            agentName: realEstateSelected() && !realtorPreviewOnly ? agentNameInput?.value.trim() || '' : '',
            brokerage: realEstateSelected() && !realtorPreviewOnly ? brokerageInput?.value.trim() || '' : '',
            recipientType: realEstateSelected() && !realtorPreviewOnly ? recipientTypeInput?.value || 'both' : '',
            realtorPreviewOnly,
            detailLevel: detailLevel(),
            asyncPreview: true,
            consent: consent.checked,
            photo: await asDataUrl(file)
          })
        });
        let payload = await readJson(response);
        if (!response.ok) throw new Error(payload.error || 'The preview service could not create this image. Please try again.');
        payload = await waitForPreview(payload);
        currentPayload = payload;

        clearProgressTimers();
        setProgress(100);
        if (generatedPreview) {
          generatedPreview.src = payload.imageUrl;
          generatedPreview.hidden = false;
        }
        setPreviewPosition(50);
        const destination = preview.dataset.previewProductUrl || payload.productUrl || '#packages';
        if (skipPreviewLink) skipPreviewLink.href = destination;
        trackPreviewComplete(payload);
        window.setTimeout(() => {
          creating.hidden = true;
          ready.hidden = false;
        }, 180);
      } catch (error) {
        clearProgressTimers();
        creating.hidden = true;
        start.hidden = false;
        showError(error instanceof Error ? error.message : 'The preview could not be created. Please try again.');
      } finally {
        busy = false;
        valid();
      }
    });

    skipPreviewLink?.addEventListener('click', (event) => {
      event.preventDefault();
      clearRememberedPreview();
      window.location.assign(skipPreviewLink.href);
    });

    deleteButton?.addEventListener('click', async () => {
      if (!isLive || !currentPayload) return;
      if (!window.confirm('Delete the uploaded original and generated preview now?')) return;
      deleteButton.disabled = true;
      try {
        const response = await fetch(actionEndpoint('delete'), {
          method:'POST',
          headers:{'content-type':'application/json'},
          body:JSON.stringify({ projectId:currentPayload.projectId, previewToken:currentPayload.previewToken })
        });
        const payload = await readJson(response);
        if (!response.ok) throw new Error(payload.error || 'We could not delete this preview.');
        currentPayload = null;
        resetButton.click();
        showError('Your original photo and preview were deleted from our storage.');
      } catch (error) {
        showError(error instanceof Error ? error.message : 'We could not delete this preview.');
        deleteButton.disabled = false;
      }
    });

    resetButton.addEventListener('click', () => {
      clearProgressTimers();
      ready.hidden = true;
      creating.hidden = true;
      start.hidden = false;
      setProgress(0);
      setPreviewPosition(50);
      if (generatedPreview) {
        generatedPreview.hidden = true;
        generatedPreview.removeAttribute('src');
      }
      if (errorMessage) errorMessage.hidden = true;
      clearRememberedPreview();
      currentPayload = null;
      if (deleteButton) deleteButton.disabled = false;
      busy = false;
      valid();
    });
  });

  document.querySelectorAll('[data-sample-library]').forEach((library) => {
    const tabs = Array.from(library.querySelectorAll('[data-sample-tab]'));
    const panels = Array.from(library.querySelectorAll('[data-sample-panel]'));
    if (!tabs.length || !panels.length) return;

    const activateSample = (key, moveFocus = false) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.sampleTab === key;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) tab.focus();
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.samplePanel !== key;
      });
    };

    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => activateSample(tab.dataset.sampleTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = tabIndex;
        if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activateSample(tabs[nextIndex].dataset.sampleTab, true);
      });
    });

    library.querySelectorAll('[data-sample-open]').forEach((button) => {
      button.addEventListener('click', () => {
        activateSample(button.dataset.sampleOpen);
        window.requestAnimationFrame(() => {
          library.querySelector('.guided-samples-heading')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });

    activateSample(tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.sampleTab || tabs[0].dataset.sampleTab);
  });

  document.querySelectorAll('[data-book-viewer]').forEach((book) => {
    const pages = Array.from(book.querySelectorAll('[data-book-page]'));
    const targets = Array.from(book.querySelectorAll('[data-book-target]'));
    const prev = book.querySelector('[data-book-prev]');
    const next = book.querySelector('[data-book-next]');
    const current = book.querySelector('[data-book-current]');
    const total = book.querySelector('[data-book-total]');
    const pageName = book.querySelector('[data-book-page-name]');
    const progress = book.querySelector('[data-book-progress]');
    const modeButtons = Array.from(book.querySelectorAll('[data-book-mode]'));
    const viewer = book.querySelector('.book-viewer');
    const stack = book.querySelector('.book-page-stack');
    const spreadMedia = window.matchMedia('(min-width: 1181px)');
    const supportsMemorySpreads = Boolean(book.closest('.sample-library-panel--complete'));
    let active = 0;
    let visibleIndices = [0];
    let touchStart = null;

    total.textContent = String(pages.length);
    const hydratePage = (page) => {
      if (!page) return;
      page.querySelectorAll('[data-book-src]').forEach((image) => {
        if (!image.getAttribute('src')) image.setAttribute('src', image.dataset.bookSrc);
      });
    };
    const show = (index) => {
      const requested = Math.max(0, Math.min(index, pages.length - 1));
      const spreadKey = pages[requested]?.dataset.bookSpread;
      visibleIndices = supportsMemorySpreads && spreadMedia.matches && spreadKey
        ? pages.reduce((matches, page, pageIndex) => {
            if (page.dataset.bookSpread === spreadKey) matches.push(pageIndex);
            return matches;
          }, [])
        : [requested];
      active = visibleIndices[0];
      const lastVisible = visibleIndices[visibleIndices.length - 1];
      visibleIndices.forEach((pageIndex) => hydratePage(pages[pageIndex]));
      hydratePage(pages[lastVisible + 1]);
      stack?.classList.toggle('is-spread', visibleIndices.length > 1);
      pages.forEach((page, pageIndex) => {
        const selected = visibleIndices.includes(pageIndex);
        page.hidden = !selected;
        page.classList.toggle('is-active', selected);
        if (selected) {
          page.classList.remove('is-turning');
          window.requestAnimationFrame(() => page.classList.add('is-turning'));
        }
      });
      targets.forEach((target, targetIndex) => target.classList.toggle('is-active', visibleIndices.includes(targetIndex)));
      const activeTarget = targets[active];
      const targetList = activeTarget?.parentElement;
      if (activeTarget && targetList && targetList.scrollHeight > targetList.clientHeight) {
        const upper = activeTarget.offsetTop;
        const lower = upper + activeTarget.offsetHeight;
        if (upper < targetList.scrollTop) targetList.scrollTop = upper;
        if (lower > targetList.scrollTop + targetList.clientHeight) targetList.scrollTop = lower - targetList.clientHeight;
      }
      current.textContent = visibleIndices.length > 1 ? `${active + 1}–${lastVisible + 1}` : String(active + 1);
      pageName.textContent = pages[active].dataset.spreadTitle || pages[active].dataset.title || `Page ${active + 1}`;
      progress.style.width = `${((lastVisible + 1) / pages.length) * 100}%`;
      prev.disabled = active === 0;
      next.disabled = lastVisible === pages.length - 1;
    };
    targets.forEach((target) => target.addEventListener('click', () => show(Number(target.dataset.bookTarget))));
    prev.addEventListener('click', () => show(active - 1));
    next.addEventListener('click', () => show(visibleIndices[visibleIndices.length - 1] + 1));
    viewer.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(visibleIndices[visibleIndices.length - 1] + 1); }
    });
    viewer.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    viewer.addEventListener('touchend', (event) => {
      if (touchStart === null) return;
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 55) show(distance < 0 ? visibleIndices[visibleIndices.length - 1] + 1 : active - 1);
      touchStart = null;
    }, { passive: true });
    spreadMedia.addEventListener?.('change', () => show(active));
    modeButtons.forEach((button) => button.addEventListener('click', () => {
      const mode = button.dataset.bookMode;
      book.dataset.colorMode = mode;
      modeButtons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
    }));
    show(0);
  });

  document.querySelectorAll('[data-product-page]').forEach((productPage) => {
    const variant = productPage.querySelector('[data-variant-select]');
    const price = productPage.querySelector('[data-product-price]');
    const printCopies = productPage.querySelector('[data-print-copies-property]');
    const productForm = productPage.querySelector('.product-form');
    const submitButton = productPage.querySelector('[data-product-submit]');
    const standardSubmit = productPage.querySelector('[data-standard-submit]');
    const realtorSubmit = productPage.querySelector('[data-realtor-submit]');
    const standardOrderFields = productPage.querySelector('[data-standard-order-fields]');
    const realtorOrderFields = productPage.querySelector('[data-realtor-order-fields]');
    const realtorBookTypeField = productPage.querySelector('[data-realtor-book-type]');
    const recipientChoices = [...productPage.querySelectorAll('[data-realtor-recipient]')];
    const quantityField = productPage.querySelector('[data-order-quantity]');
    const quantityWrap = productPage.querySelector('[data-order-quantity-wrap]');
    const bookLinks = document.querySelector('[data-product-book-links]');
    const gallerySample = productPage.querySelector('[data-product-gallery-sample]');
    const galleryRealEstate = productPage.querySelector('[data-product-gallery-real-estate]');
    const realtorGalleryCovers = [...productPage.querySelectorAll('[data-realtor-gallery-cover]')];
    const realtorGalleryPair = productPage.querySelector('[data-realtor-gallery-pair]');
    const realtorGalleryCaption = productPage.querySelector('[data-realtor-gallery-caption]');
    const syncSelectedVariant = () => {
      const option = variant.options[variant.selectedIndex];
      if (option && option.dataset.price && price) price.textContent = option.dataset.price;
      if (option && printCopies) printCopies.value = option.dataset.printCopies || '1';
    };
    if (variant) variant.addEventListener('change', syncSelectedVariant);
    try {
      const requestedProductBookType = referralParams.get('book');
      const requestedBookIsKnown = Boolean(requestedProductBookType && Object.prototype.hasOwnProperty.call(bookTypeLabels, requestedProductBookType));
      const bookType = requestedBookIsKnown ? requestedProductBookType : 'family';
      const savedCollaboratorId = normalizeCollaboratorId(sessionStorage.getItem('ck_collaborator_id')) || collaboratorId;
      const bookTypeField = productPage.querySelector('[data-order-book-type]');
      const collaboratorField = productPage.querySelector('[data-collaborator-id]');
      const afterCheckoutCopy = productPage.querySelector('[data-after-checkout-copy]');
      if (bookType && bookTypeField) bookTypeField.value = bookTypeLabels[bookType] || bookType;
      const requestedCopies = Number(referralParams.get('copies'));
      const requestedRecipient = String(referralParams.get('recipient') || '').toLowerCase();
      const syncRecipient = () => {
        const selected = recipientChoices.find(choice => choice.checked) || recipientChoices[0];
        if (!selected) return;
        const copies = selected.dataset.copies === '2' ? 2 : 1;
        const totalPrice = selected.dataset.totalPrice || '';
        const selection = selected.value;
        if (quantityField) quantityField.value = String(copies);
        if (printCopies) printCopies.value = '1';
        if (price && totalPrice) price.textContent = totalPrice;
        if (realtorSubmit) realtorSubmit.textContent = `Continue to secure checkout${totalPrice ? ` — ${totalPrice}` : ''} →`;
        realtorGalleryCovers.forEach((cover) => {
          cover.hidden = selection === 'Both buyer and seller' || cover.dataset.realtorGalleryCover !== selection;
        });
        if (realtorGalleryPair) realtorGalleryPair.hidden = selection !== 'Both buyer and seller';
        if (realtorGalleryCaption) {
          realtorGalleryCaption.textContent = selection === 'Both buyer and seller'
            ? 'Two separate 8.5 × 11 hardcover books · one Buyer Book + one Seller Book'
            : selection === 'Seller'
              ? 'Thank You, Home Seller Book · one separate 8.5 × 11 hardcover'
              : 'Welcome Home Buyer Book · one separate 8.5 × 11 hardcover';
        }
      };
      const syncOrderType = () => {
        const realEstateSelected = bookType === 'realestate' || bookTypeField?.value === 'Real estate closing keepsake';
        productPage.classList.toggle('is-real-estate', realEstateSelected);
        document.documentElement.classList.toggle('book-real-estate', realEstateSelected);
        if (standardOrderFields) standardOrderFields.hidden = realEstateSelected;
        if (bookTypeField) bookTypeField.disabled = realEstateSelected;
        if (realtorOrderFields) {
          realtorOrderFields.hidden = !realEstateSelected;
          realtorOrderFields.disabled = !realEstateSelected;
        }
        if (realtorBookTypeField) realtorBookTypeField.disabled = !realEstateSelected;
        if (quantityWrap) quantityWrap.hidden = realEstateSelected;
        if (bookLinks) bookLinks.hidden = realEstateSelected;
        if (gallerySample) gallerySample.hidden = realEstateSelected;
        if (galleryRealEstate) galleryRealEstate.hidden = !realEstateSelected;
        if (afterCheckoutCopy) afterCheckoutCopy.textContent = realEstateSelected
          ? 'Immediately after payment, open one private form to add the property address, photo permission, buyer or seller names, presentation date, closing message, professional headshot, and company logo. We handle the photos and design, then email the complete 60-page proof for your approval before printing.'
          : 'Your private setup form opens immediately and is emailed to you. Add the book details, upload and arrange all 12 book photos, then finish now or return later. Any free preview remains separate, and nothing prints until you approve the complete proof.';
        const mobileCta = document.querySelector('[data-mobile-preview-cta]');
        if (mobileCta && realEstateSelected) {
          const productInfo = productPage.querySelector('.product-info');
          mobileCta.href = productInfo?.id ? `#${productInfo.id}` : '#MainContent';
          mobileCta.innerHTML = 'Choose buyer or seller <span aria-hidden="true">→</span>';
        }
        if (realEstateSelected) syncRecipient();
      };
      const desiredRecipient = requestedCopies === 2 || requestedRecipient === 'both'
        ? 'Both buyer and seller'
        : requestedRecipient === 'seller' ? 'Seller' : 'Buyer';
      const matchingRecipient = recipientChoices.find(choice => choice.value === desiredRecipient);
      if (matchingRecipient) matchingRecipient.checked = true;
      recipientChoices.forEach(choice => choice.addEventListener('change', syncRecipient));
      if (collaboratorField) collaboratorField.value = savedCollaboratorId;
      syncOrderType();

      productForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!productForm.reportValidity()) return;
        const originalDisabled = submitButton?.disabled;
        if (submitButton) submitButton.disabled = true;
        if (realtorSubmit) realtorSubmit.textContent = 'Opening secure checkout…';
        if (standardSubmit) standardSubmit.textContent = 'Opening secure checkout…';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(productForm)
          });
          if (!response.ok) throw new Error('This selection could not be added to checkout.');
          window.location.assign(`${root}checkout`);
        } catch (error) {
          if (submitButton) submitButton.disabled = Boolean(originalDisabled);
          if (standardSubmit) standardSubmit.textContent = 'Continue to secure checkout →';
          syncRecipient();
          window.alert(error.message || 'Checkout could not be opened. Please try again.');
        }
      });
    } catch (_) {}
  });

  document.querySelectorAll('[data-book-idea]').forEach((button) => button.addEventListener('click', () => {
    const type = button.dataset.bookIdea;
    const customIdea = button.dataset.bookCustomIdea || '';
    document.querySelectorAll('[data-book-type], [data-ck-book-type]').forEach((select) => {
      select.value = type;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (customIdea) {
      document.querySelectorAll('[data-custom-idea]').forEach((input) => {
        input.value = customIdea;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }
    try { sessionStorage.setItem('ck_book_type', type); } catch (_) {}
    document.querySelector('#create')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }));

  const mobilePreviewCta = document.querySelector('[data-mobile-preview-cta]');
  if (mobilePreviewCta) {
    const creator = document.querySelector('#create');
    if (!creator || !('IntersectionObserver' in window)) mobilePreviewCta.classList.add('is-visible');
    else new IntersectionObserver(([entry]) => mobilePreviewCta.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.15 }).observe(creator);
  }

  const firstOrderOffer = document.querySelector('[data-first-order-offer]');
  if (firstOrderOffer) {
    const storageKey = 'you_outlined_first_order_offer_seen_v5';
    const closeButtons = firstOrderOffer.querySelectorAll('[data-offer-close]');
    const openButtons = document.querySelectorAll('[data-offer-open]');
    const acceptButton = firstOrderOffer.querySelector('[data-offer-accept]');
    const copyButton = firstOrderOffer.querySelector('[data-copy-discount]');
    const closeButton = firstOrderOffer.querySelector('.first-order-offer__close');
    let previouslySeen = false;
    let offerTimer;
    try { previouslySeen = window.localStorage.getItem(storageKey) === '1'; } catch (_) {}

    const rememberOffer = () => {
      try { window.localStorage.setItem(storageKey, '1'); } catch (_) {}
    };
    const dismissOffer = () => {
      rememberOffer();
      firstOrderOffer.hidden = true;
      document.body.classList.remove('offer-open');
    };
    const showOffer = () => {
      if (offerTimer) window.clearTimeout(offerTimer);
      firstOrderOffer.hidden = false;
      document.body.classList.add('offer-open');
      window.setTimeout(() => closeButton?.focus(), 50);
    };

    closeButtons.forEach((button) => button.addEventListener('click', dismissOffer));
    openButtons.forEach((button) => button.addEventListener('click', showOffer));
    acceptButton?.addEventListener('click', dismissOffer);
    copyButton?.addEventListener('click', async () => {
      const code = copyButton.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
        const label = copyButton.querySelector('em');
        if (label) label.textContent = 'Copied!';
        window.setTimeout(() => { if (label) label.textContent = 'Copy'; }, 1800);
      } catch (_) {}
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !firstOrderOffer.hidden) dismissOffer();
    });

    if (!previouslySeen) {
      const delay = Number(firstOrderOffer.dataset.offerDelay) || 5000;
      offerTimer = window.setTimeout(showOffer, Math.max(500, delay));
    }
  }
});
